/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], p[_ngcontent-%COMP%], span[_ngcontent-%COMP%], label[_ngcontent-%COMP%] {\n	\n}\n\n.container[_ngcontent-%COMP%] {\n	margin-top:25px;\n}\n\na[_ngcontent-%COMP%] {\n	text-decoration: underline;\n}\n\n\n\n.content[_ngcontent-%COMP%] {\n	padding: 50px 30px;\n}\n\n.content[_ngcontent-%COMP%]   p[_ngcontent-%COMP%] {\n	padding: 10px 0;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL0NocmlzL0RvY3VtZW50cy9XZWJEZXYvRGV2R2VuQW5nL3NyYy9hcHAvdGhhbmt5b3UvdGhhbmt5b3UuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9DaHJpcy9Eb2N1bWVudHMvV2ViRGV2L0RldkdlbkFuZy9zcmMvYXBwL3RoYW5reW91L3RoYW5reW91LmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/thankyou/thankyou.component.css.shim.ngstyle.ts